import React, {useState, useContext} from 'react';
import styled from 'styled-components';
import {OverlayContext} from '../contexts/OverlayContext';

import {OzButton, OzCard, OzSelect, OzCol, OzRow, OzLoading} from '@ozwol/webui';

import WebhooksService from '../services/WebhooksService';

import CardHeaderTitle from '../components/CardHeaderTitle';

import ErrorMessage from '../components/ErrorMessage';
import SuccessMessage from '../components/SuccessMessage';

import {formatError} from '../helpers';

const Container = styled.div`
  width: 450px;
`;


const ModalVerifyWebhook = ({item}) => {
  const {removeOverlay} = useContext(OverlayContext);
  const [testevent, setTestevent] = useState(item.events[0]);
	const [errorMessage, setErrorMessage] = useState(false);
	const [successMessage, setSuccessMessage] = useState(false);
	const [testLoading, setTestLoading] = useState(false);

  return (
    <Container>

      <OzCard
        headerLeft={
          <CardHeaderTitle 
            title={"Test"} 
          />
        }
        headerSeparator={true}
        footerLeft={<OzButton variant={"chetwodeblue-o"} onClick={() => removeOverlay("webhook")}>Cancel</OzButton>}
        footerRight={<OzButton disabled={!testevent} variant={"silvertree"} onClick={() => 
					WebhooksService.test(item.uuid, {event: testevent}).then((response) => {
						setSuccessMessage("Your webhook is valid.");
						setErrorMessage(null);
						setTestLoading(false);
					}).catch((error) => {
						setErrorMessage(formatError(error));
						setSuccessMessage(null);
						setTestLoading(false);
					})
				}>Test</OzButton>}
      >
        Test the correct notification for the following event.

        <br/>
				<OzRow>
					<OzCol widthmd="12">
						<OzSelect 
							label="Event"
							selected={testevent}
							maxHeight={"400px"}
							width={"100%"}
							values={item.events.map((item) => ({
								"name": item,
								"value": item
							}))}
							onChange={(val) => setTestevent(val)}
						/>
					</OzCol>
				</OzRow>
			
				<SuccessMessage>
					{successMessage}
				</SuccessMessage>
				<ErrorMessage>
					{errorMessage}
				</ErrorMessage>

				{testLoading ? 
					<OzLoading />
				: null }

      </OzCard>

    </Container>
  );

}

export default ModalVerifyWebhook;
